var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container-chart",staticClass:"chart-wrap"},[_c('highcharts',{ref:"pieIdChart",attrs:{"options":_vm.options}}),_c('div',{staticClass:"center-absolute",staticStyle:{"height":"auto!important"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }